'use client';

import { NotFoundIcon } from '@cloudquery/base-icons';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

interface Props {
  href: string;
}

export function NotInitialized({ href }: Props) {
  return (
    <Container
      component="main"
      maxWidth="xl"
      sx={{
        alignItems: 'center',
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column',
        justifyContent: 'center',
        paddingY: 10,
      }}
    >
      <Box display="flex" justifyContent="center" marginBottom={3}>
        <NotFoundIcon sx={{ height: 128, width: 'auto' }} />
      </Box>
      <Typography align="center" marginBottom={1} variant="h5">
        The Asset Inventory table has not been initialized yet.
      </Typography>
      <Typography align="center" marginBottom={3} sx={{ color: 'text.secondary' }} variant="body1">
        Click below to sync data.
      </Typography>
      <Box display="flex" justifyContent="center" marginBottom={6}>
        <Button
          component={Link}
          endIcon={<ChevronRightIcon />}
          href={href}
          size="medium"
          variant="contained"
        >
          Take Me To Sync Instructions
        </Button>
      </Box>
    </Container>
  );
}
